// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3IVL7","colMin":"styles_colMin__1vLdi","colCheckbox":"styles_colCheckbox__d6zAt"};